import UpdatePassword from "../../Customer/UpdatePassword"
//import PinCodeSignIn from '../../../components/PinCodeSignIn'

const DriverOnboard = () => {
  return <UpdatePassword />
}

export default DriverOnboard
